<template>
  <div class="order-manage-page">
    <el-form :model="queryCondition" :inline="true" label-position="left">
      <el-form-item label="订单号">
        <el-input v-model="queryCondition.SalesCode" placeholder="SA20200420"></el-input>
      </el-form-item>
      <el-form-item label="客户">
        <el-input v-model="queryCondition.GuestName" placeholder="输入客户名"></el-input>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="queryCondition.FormStatus" placeholder="请选择">
          <el-option v-for="item in statusOp" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onBtnSearch">查询</el-button>
      </el-form-item>
    </el-form>

    <div>
      <el-pagination @size-change="onSizeChange" @current-change="onCurrentChange" :current-page="queryCondition.pageindex" :page-sizes="[15,20,30,50,100]" :page-size="queryCondition.pagesize" layout="total,sizes,prev,pager,next,jumper" :total="queryCondition.count" >
      </el-pagination>
    </div>
    <el-table :data="orderList" border style="width: 100%" v-loading="loading">
      <el-table-column prop="SalesCode" label="单号" width="180">
        <template slot-scope="scope">
          <a :href="'/#/sales/order_detail/'+scope.row.SalesCode" target="_blank">{{scope.row.SalesCode}}</a>
        </template>
      </el-table-column>
      <el-table-column prop="GuestName" label="客户" width="180"></el-table-column>
      <el-table-column prop="TotalPrice" label="总金额"></el-table-column>
      <el-table-column prop="DiscountAmount" label="折扣金额"></el-table-column>
      <el-table-column prop="CreateDate" label="建单时间" width="180"></el-table-column>
      <el-table-column prop="FormStatusName" label="状态"></el-table-column>
    </el-table>
  </div>
</template>

<script>
import {searchOrders,getOrderInfo} from '../../api/order'
import {fmtTime} from '../../api/utils'

export default {
  data() {
    return {
      queryCondition: {SalesCode:"", GuestName:"", FormStatus: '100', pageindex: 1, pagesize: 20, count: 0},
      statusOp: [{value: '100',label: '全部'}, {value: '0',label: '已保存'}, {value: '1',label: '已提交'}, {value: '2',label: '同步'}, {value: '-1',label: '已取消'}],
      orderList:[],
      dlgAddSetting:false,
      editSetting: {ID:0, TypeCode:"", TypeName:"", SetName:"", SetValue:"", Enable: 1},
      loading:false,
      rules:{
        TypeName:[{ required: true, message: '请输入说明', trigger: 'blur' }],
        TypeCode:[{ required: true, message: '请输入分类编码', trigger: 'blur' }],
        SetName:[{ required: true, message: '请输入配置名', trigger: 'blur' }]
      }
    };
  },
  created(){
    this.onSearch();
  },
  methods:{
    onBtnSearch:function(){
      this.queryCondition.pageindex = 1;
      this.onSearch();
    },
    onSearch:function(){
      var that = this;
      this.loading = true
      searchOrders(this.queryCondition).then(resp=>{
        that.loading = false
        if (resp.data.code == 100){
          for (var i = 0; i < resp.data.data.Data.length; i++){
            resp.data.data.Data[i].CreateDate = fmtTime(resp.data.data.Data[i].CreateDate);
            resp.data.data.Data[i].FormStatusName = that.getStatusName(resp.data.data.Data[i].FormStatus)
          }
          that.orderList = resp.data.data.Data;
          that.queryCondition.count = resp.data.data.Count;
        }else{
          that.$notify.error({title: '失败',message: "加载数据失败：" + resp.data.msg})
        }
      },err=>{
        that.loading = false
        that.$notify.error({title:'查询失败',message:err.statusText})
      });
    },
    getStatusName:function(status){
      switch(status){
        case 0: return "已保存";
        case 1: return "已提交";
        case 2: return "同步";
        case 3: return "已结算";
        case -1: return "已取消";
        default: return "其他";
      }
    },
    onSizeChange(curSize){
      this.queryCondition.pagesize = curSize;
      this.queryCondition.pageindex = 1;
      this.onSearch();
    },
    onCurrentChange(curIndex){
      this.queryCondition.pageindex = curIndex;
      this.onSearch();
    }
  }
}
</script>
